import React from 'react';

interface IIconProps {
  style?: any;
  fillColor?: string;
}

const RemoveIcon:React.FC<IIconProps> = (props: IIconProps) => {
  return (    
    <svg width="13" height="16" viewBox="0 0 13 16" fill="none" xmlns="http://www.w3.org/2000/svg" style={props.style}>
    <path d="M13 2v.8c0 .22-.182.4-.406.4H.406A.403.403 0 0 1 0 2.8V2c0-.22.182-.4.406-.4h3.656V.8c0-.442.364-.8.813-.8h3.25c.449 0 .813.358.813.8v.8h3.656c.224 0 .406.18.406.4zM1.52 14.512c.06.84.77 1.49 1.624 1.488h6.728a1.615 1.615 0 0 0 1.625-1.488l.69-9.712H.813l.706 9.712z" fill="#112240"/>
</svg>

  )
}

export default RemoveIcon;